module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAADlSURBVFjD7daxEYQgEAVQSrgSLOGyTSnBEizBZHM7oARKsARLsARLsIR/iXp6AjoOsBfAzA93eaMsqgCoLUyIkBlMFky18qz9nioBYJ8RTG9JwJpGGnBASAGwvo4QoPvJFGjWOWKXQ+irGYKA02FhGnzNvCec6QWmPoDQSQE3am0uQOUdzRyAYH1GgJEGyD2BZRpcIznlAhhPbZ8cAKY2dCVHAYBJO9Jc1ExKRboJH6aWBNitrwDAHvpmBMxgak99IwHGi40NmCrnlMQaw+WDo/H9H6jh+AdMBni6CqAACqAA/grwAShY7i5oYPbSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/assets/file-icons/powerpoint.png
// module id = 1618
// module chunks = 0